import { Button, Dialog, DialogActions, DialogContent, DialogTitle, InputLabel, TextField } from "@mui/material"
import axios from '../../util/Axios';
import { useState } from "react";

function TestDeleteDialog({ isOpen, handleClose, testId, setTestId, updateTests }) {

    const [reason, setReason] = useState();

    const handleCloseDialog = () => {
        setTestId(null);
        setReason('');
        handleClose();
    };

    const handleSoftDeletion = async () => {
        try {

            const response = await axios(`/strokeTests/${testId}/deleteTest`, {
                method: 'PUT',
                data: {
                    active: false,
                    deleteReason: reason,
                },
            });

            if (response.status === 200) {
                updateTests();
                handleCloseDialog();
            } 

        } catch (error) {
            console.error("Failed to delete test!", error);
        }
    };

    return (
        <Dialog open={isOpen} onClose={handleCloseDialog}>
            <DialogTitle>
                Do you really want to delete the test ?
            </DialogTitle>
            <DialogContent>
                <InputLabel>Reason (optional)</InputLabel>
                <TextField
                    variant="standard"
                    multiline
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                />
            </DialogContent>
            <DialogActions sx={{padding: '1rem'}}>
                <Button variant="outlined" onClick={handleCloseDialog}>Cancel</Button>
                <Button variant="contained" onClick={handleSoftDeletion}>Confirm</Button>
            </DialogActions>
        </Dialog>
    )
}

export default TestDeleteDialog